/**
 * Énumération des types d'opérateurs logiques entre les règles
 */
export enum TypeRuleOperator {
	AND = "AND",
	OR = "OR"
}